import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { ProductIntro } from './ProductIntro';
import { Transformation } from './Transformation';
import { TomosList } from './TomosList';
import { Bonos } from './Bonos';
import { WhatYouGet } from './WhatYouGet';
import { Urgency } from './Urgency';
import { Pricing } from './Pricing';
const LateContent = lazy(() => import('./LateContent').then(({
  LateContent: Content
}) => ({
  default: Content
})));
interface DeferredContentProps {
  onCta: () => void;
  onReady: () => void;
}

/** Long-form sales content stays outside the critical rendering path. */
export function DeferredContent({
  onCta,
  onReady
}: DeferredContentProps) {
  const lateContentTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadLateContent, setShouldLoadLateContent] = useState(false);
  useEffect(() => {
    onReady();
  }, [onReady]);
  useEffect(() => {
    const trigger = lateContentTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadLateContent(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadLateContent(true);
      observer.disconnect();
    }, {
      rootMargin: '420px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  return <>
      <ProductIntro data-id="element-46" data-mp="2w2oefjnzdtoq" />
      <Transformation data-id="element-47" data-mp="2w1wfpzz37fu8" />
      <TomosList data-id="element-48" data-mp="2w5kcr93qqkdp" />
      <Bonos data-id="element-49" data-mp="2r4wjshvybtgu" />
      <WhatYouGet data-id="element-50" data-mp="2r5frz6vsv3ho" />
      <Urgency data-id="element-51" data-mp="2r3uwnf1nvgir" />
      <div id="pricing" className="scroll-mt-4" data-id="element-52" data-mp="2r4egj1avgezf">
        <Pricing data-id="element-53" data-mp="354xlu0nyd6xw" />
      </div>
      <div ref={lateContentTriggerRef} className="h-px" aria-hidden="true" data-id="element-54" data-mp="3534eej5imiou" />
      {shouldLoadLateContent && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-56" data-mp="313lqrfmb7tib" />} data-id="element-55" data-mp="3145bf43cgw01">
          <LateContent onCta={onCta} data-id="element-57" data-mp="1apmowqljvbr6" />
        </Suspense>}
    </>;
}